import { render, staticRenderFns } from "./StatusImportacaoPedido.vue?vue&type=template&id=eaa149ce"
import script from "./StatusImportacaoPedido.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusImportacaoPedido.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports